module.exports = __webpack_public_path__ + "media/dashboard/assets/images/menu-icons/chats-circle-3815e53604a007206cd7dd3d69146a9a.svg";